// src/App.js
import React from "react";
import LandingPage from "./components/LandingPage";
import SplitImageGrid from "./components/SplitImageGrid";
import ImageResizer from "./components/ImageResizer";

function App() {
  return (
    <div>
      <LandingPage />
      <SplitImageGrid />
      <ImageResizer />
    </div>
  );
}

export default App;
